import axios from "axios";
import {
    url_reporting_period,
    url_reporting_period_add_branch,
    url_reporting_period_delete,
    url_reporting_period_delete_branch,
    url_reporting_period_status,
    url_reporting_periods
} from "../url";

export default function DB_ReportingPeriod (token) {
    const formData = new FormData;
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }



    const getReportingPeriods = () => {
        return axios.post(url_reporting_periods, formData)
    }


    const getReportingPeriod = (id) => {
        return axios.post(url_reporting_period + id, formData)
    }


    const createReportingPeriod = (data) => {
        return axios.post(url_reporting_period, appendToken(data))
    }


    const updateReportingPeriod = (data) => {
        return axios.put(url_reporting_period, appendToken(data))
    }


    const statusBranch = (data) => {
        return axios.post(url_reporting_period_status, appendToken(data))
    }

    const addBranches = (data) => {
      return axios.post(url_reporting_period_add_branch, appendToken(data))
    }

    const deleteBranch = (data) => {
        return axios.post(url_reporting_period_delete_branch, appendToken(data))
    }

    const deleteReportingPeriod = (data) => {
        return axios.post(url_reporting_period_delete, appendToken(data))
    }

    return {
        getReportingPeriods,
        getReportingPeriod,
        createReportingPeriod,
        updateReportingPeriod,
        deleteReportingPeriod,
        statusBranch,
        addBranches,
        deleteBranch,
    }
}
